import { FC, ReactNode } from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import classes from './IssueInfoItem.module.scss';

export interface IssueInfoItemProps {
  label: string;
  value: ReactNode;
  isHighlight?: boolean;
  className?: string;
  tooltip?: string;
  /** 라벨 아래에 값을 세로로 배치하고 값을 좌측 정렬한다. 본문 등 긴 텍스트에 사용. */
  vertical?: boolean;
}

export const IssueInfoItem: FC<IssueInfoItemProps> = ({
  label,
  value,
  isHighlight = false,
  className = '',
  tooltip,
  vertical = false,
}) => {
  return (
    <div className={`${classes.infoItem} ${vertical ? classes.vertical : ''} ${className}`}>
      <div className={classes.label}>
        {label}
        {tooltip && (
          <Tooltip title={tooltip}>
            <InfoCircleOutlined className={classes.icon} />
          </Tooltip>
        )}
      </div>
      <div className={`${classes.value} ${isHighlight ? classes.highlight : ''}`}>{value}</div>
    </div>
  );
};
